import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import Header from "../../../components/Header/Header";
import Grid from "@mui/material/Grid";
import { Container, Card, Button, TextField, Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { NavLink } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { AgGridReact } from "ag-grid-react";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  getFinish,
  addFinish,
  getSingleFinish,
  updateFinish,
  deleteFinish,
} from "./finishSlice";
import { ToastContainer } from "react-toastify";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import { getUomList } from "../UOM/uomSlice";
import { getCategoryList } from "../Categories/categorySlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const finishSchema = Yup.object().shape({
  category_id: Yup.string().required("Category is Required"),
  name: Yup.string().required("Name is Required"),
  uom_id: Yup.string().required("UOM is Required"),
});

const Finish = () => {
  const finishList = useSelector((state) => state.finish);
  const uomList = useSelector((state) => state.uom);
  const categoryList = useSelector((state) => state.category);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFinish());
    dispatch(getUomList());
    dispatch(getCategoryList());
  }, []);

  const [openAdd, setOpenAdd] = React.useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const [deleteId, setDeleteId] = useState("");

  const [openEdit, setOpenEdit] = React.useState(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleOpenEdit = (e) => {
    setOpenEdit(true);
    dispatch(getSingleFinish(e));
  };

  const [categories, setCategory] = React.useState([]);
  const [uoms, setUom] = React.useState([]);
  useEffect(() => {
    setCategory(categoryList.categorylists);
    setUom(uomList.uomLists);
  }, [categoryList.categorylists]);

  const [openDelete, setOpenDelete] = React.useState(false);
  const handleClickOpenDelete = (e) => {
    setOpenDelete(true);
    setDeleteId(e);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleRemove = () => {
    dispatch(deleteFinish(deleteId));
    setOpenDelete(false);
  };

  const [rowData, setRowData] = useState();
  useEffect(() => {
    setRowData(finishList.finishes);
  }, [finishList.finishes]);

  const [columnDefs] = useState([
    {
      field: "category",
      headerName: "Category",
      sortable: true,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      field: "name",
      headerName: "Name",
      sortable: true,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      field: "uom",
      headerName: "UOM",
      sortable: true,
      cellStyle: { borderRightColor: "#e2e2e2" },
    },
    {
      field: "action",
      headerName: "Action",
      cellRenderer: function (params) {
        return (
          <div>
            <IconButton
              aria-label="edit"
              color="primary"
              onClick={() => handleOpenEdit(params.data.id)}
            >
              <CreateIcon />
            </IconButton>
            <IconButton
              aria-label="delete"
              color="error"
              onClick={() => handleClickOpenDelete(params.data.id)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        );
      },
      maxWidth: 120,
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      // resizable: true,
      sortable: true,
      wrapText: true, // <-- HERE
      autoHeight: true,
    };
  }, []);

  return (
    <>
      <Header />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card
              sx={{ maxWidth: 1300 }}
              className="mt-30"
              style={{ backgroundColor: "#f2f2f2", display: "flex" }}
            >
              <Grid item xs={3}>
                <div className="setting-nav-menu">
                  <ul>
                    <li className="nav-item">
                      <NavLink to="/settings/uoms">
                        Units Of Measure{" "}
                        <span>
                          <ArrowForwardIosIcon />
                        </span>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/settings/taxRates">
                        Tax Rates{" "}
                        <span>
                          <ArrowForwardIosIcon />
                        </span>
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink to="/settings/categories">
                        Categories{" "}
                        <span>
                          <ArrowForwardIosIcon />
                        </span>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/settings/operations">
                        Operations{" "}
                        <span>
                          <ArrowForwardIosIcon />
                        </span>
                      </NavLink>
                    </li>
                    <li className="nav-item active">
                      <NavLink to="/settings/finish">
                        Finishes{" "}
                        <span>
                          <ArrowForwardIosIcon />
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid
                item
                xs={9}
                style={{ backgroundColor: "#fff", padding: "10px 40px" }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                  className="btn-bottom"
                >
                  <h3>Finishes</h3>
                  <Button size="medium" onClick={handleOpenAdd}>
                    <span>
                      <AddIcon />
                    </span>
                    Add Finishes
                  </Button>
                </div>
                <div
                  className="ag-theme-alpine"
                  style={{ height: 500, width: 600, marginBottom: "30px" }}
                >
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                  ></AgGridReact>
                </div>
              </Grid>
            </Card>
          </Grid>
        </Grid>
        <ToastContainer />
      </Container>
      {/* Add Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseAdd}
        aria-labelledby="customized-dialog-title"
        open={openAdd}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseAdd}
        >
          Add Finishes
        </BootstrapDialogTitle>

        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            validationSchema={finishSchema}
            initialValues={{
              category_id: "",
              name: "",
              uom_id: "",
            }}
            onSubmit={async (values) => {
              dispatch(addFinish(values));
              setOpenAdd(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <TextField
                  id="category_id"
                  name="category_id"
                  select
                  label="Category"
                  defaultValue=""
                  variant="standard"
                  className="w-100 mb-10"
                  onChange={handleChange}
                >
                  {categories.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <ErrorMessage
                  component="div"
                  name="category_id"
                  className="error-message"
                />
                <TextField
                  id="name"
                  label="Name"
                  variant="standard"
                  className="w-100"
                  onChange={handleChange}
                />
                <ErrorMessage
                  component="div"
                  name="name"
                  className="error-message"
                />
                <TextField
                  id="uom_id"
                  name="uom_id"
                  select
                  label="UOM"
                  defaultValue=""
                  variant="standard"
                  className="w-100 mb-15 mt-20"
                  onChange={handleChange}
                >
                  {uoms.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <ErrorMessage
                  component="div"
                  name="uom_id"
                  className="error-message"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  autoFocus
                  className="btn-modal"
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Add Modal End */}
      {/* Edit Modal Start*/}
      <BootstrapDialog
        onClose={handleCloseEdit}
        aria-labelledby="customized-dialog-title"
        open={openEdit}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseEdit}
        >
          Edit Finishes
        </BootstrapDialogTitle>

        <DialogContent dividers style={{ width: "500px" }}>
          <Formik
            enableReinitialize={true}
            validationSchema={finishSchema}
            initialValues={{
              id: finishList.singleFinish.data
                ? finishList.singleFinish.data.id
                : "",
              name: finishList.singleFinish.data
                ? finishList.singleFinish.data.name
                : "",
              category_id: finishList.singleFinish.data
                ? finishList.singleFinish.data.category_id
                : "",
              uom_id: finishList.singleFinish.data
                ? finishList.singleFinish.data.uom_id
                : "",
            }}
            onSubmit={async (values) => {
              dispatch(updateFinish(values));
              setOpenEdit(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <TextField
                  id="category_id"
                  name="category_id"
                  select
                  label="Category"
                  defaultValue={values.category_id}
                  variant="standard"
                  className="w-100 mb-10"
                  onChange={handleChange}
                  value={values.category_id}
                >
                  {categories.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <ErrorMessage
                  component="div"
                  name="category_id"
                  className="error-message"
                />
                <TextField
                  id="name"
                  label="Name"
                  variant="standard"
                  className="w-100"
                  onChange={handleChange}
                  value={values.name}
                />
                <ErrorMessage
                  component="div"
                  name="name"
                  className="error-message"
                />
                <TextField
                  id="uom_id"
                  name="uom_id"
                  select
                  label="UOM"
                  defaultValue={values.uom_id}
                  variant="standard"
                  className="w-100 mb-15 mt-20"
                  onChange={handleChange}
                  value={values.uom_id}
                >
                  {uoms.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <ErrorMessage
                  component="div"
                  name="uom_id"
                  className="error-message"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  autoFocus
                  className="btn-modal"
                >
                  Submit
                </Button>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </BootstrapDialog>
      {/* Edit Modal End */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete the category?"}
        </DialogTitle>
        <DialogContent style={{ width: "500px" }}>
          <DialogContentText id="alert-dialog-description">
            This action cannot be undone
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>Cancel</Button>
          <Button
            onClick={handleRemove}
            variant="contained"
            color="error"
            autoFocus
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Finish;
